import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin, Mail, Phone } from 'lucide-react';
import './ContactCTAStrip.css';

const ContactCTAStrip = () => {
  const { t } = useTranslation();
  const ctaItems = [
    {
      icon: MapPin,
      label: t('contact_cta_address_label'),
      value: t('contact_cta_address_value')
    },
    {
      icon: Mail,
      label: t('contact_cta_email_label'),
      value: t('contact_cta_email_value')
    },
    {
      icon: Phone,
      label: t('contact_cta_phone_label'),
      value: t('contact_cta_phone_value')
    }
  ];

  return (
    <section className="contact-cta-strip">
      <div className="container">
        <div className="cta-grid">
          {ctaItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div key={index} className="cta-item">
                <div className="cta-icon">
                  <IconComponent size={28} />
                </div>
                <div className="cta-content">
                  <p className="cta-label">{item.label}</p>
                  <p className="cta-value">{item.value}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ContactCTAStrip;
